
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/gladly",
      function () {
        return require("private-next-pages/destinations/gladly.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/gladly"])
      });
    }
  